import { render } from "./IconTrash.vue?vue&type=template&id=2e384c84"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"
script.render = render

export default script